import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/siteTranslations';

export default function Footer() {
  const { lang } = useLanguage();
  const t = translations[lang];

  return (
    <footer className="bg-[#2C2825] text-[#FAF7F2] pt-16 pb-10 border-t border-[#3F3A35]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-[#3F3A35]">
          
          {/* Brand Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=120,quality=90,format=auto/assets/6f9e56e8-59c1-4c62-ab67-d52ab0ef33f1/massage-with-jette-mwj-heart4c.jpg"
                alt="Massage with Jette Logo"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-[#A39B92] leading-relaxed">
              {t.footer.aboutText}
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#3F3A35] text-xs text-[#EBF0EA]">
              <i className="fa-solid fa-seedling text-white" />
              <span>{lang === 'da' ? '29+ års erfaring • København' : '29+ years experience • Copenhagen'}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h3 className="font-serif-display text-lg font-semibold text-[#FAF7F2]">
              {t.footer.quickLinks}
            </h3>
            <ul className="space-y-2 text-sm text-[#A39B92]">
              <li>
                <Link to="/" className="hover:text-[#2E3191] transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/om-jette" className="hover:text-[#2E3191] transition-colors">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/behandlinger" className="hover:text-[#2E3191] transition-colors">
                  {t.nav.treatments}
                </Link>
              </li>
              <li>
                <Link to="/priser" className="hover:text-[#2E3191] transition-colors">
                  {t.nav.prices}
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-[#2E3191] transition-colors">
                  {t.nav.gallery}
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#2E3191] transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
              <li>
                <a
                  href="https://massage-with-jette.planway.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#2E3191] transition-colors text-white font-medium inline-flex items-center gap-1.5"
                >
                  <span>{lang === 'da' ? 'Online Booking (Planway)' : 'Online Booking (Planway)'}</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div className="space-y-3">
            <h3 className="font-serif-display text-lg font-semibold text-[#FAF7F2]">
              {t.footer.contactInfo}
            </h3>
            <ul className="space-y-3 text-sm text-[#A39B92]">
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-white mt-1 shrink-0" />
                <div>
                  <p className="font-medium text-[#FAF7F2]">Salig behandlerfællesskab</p>
                  <p>Masnedøgade 20, 2. sal</p>
                  <p>2100 København Ø</p>
                </div>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-white shrink-0" />
                <a
                  href="tel:81983707"
                  className="hover:text-[#2E3191] transition-colors whitespace-nowrap phone-no-break"
                >
                  81 98 37 07
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-white shrink-0" />
                <a
                  href="mailto:MassagewithJette@gmail.com"
                  className="hover:text-[#2E3191] transition-colors whitespace-nowrap email-no-break"
                >
                  MassagewithJette@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Location & Out-Calls */}
          <div className="space-y-3">
            <h3 className="font-serif-display text-lg font-semibold text-[#FAF7F2]">
              {t.location.outCallTitle}
            </h3>
            <p className="text-sm text-[#A39B92] leading-relaxed">
              {t.location.outCallText}
            </p>
            <div className="p-3.5 rounded-xl bg-[#3F3A35]/60 border border-[#4F4842] text-xs text-[#E8E0D7] space-y-1">
              <p className="font-semibold text-[#FAF7F2]">{t.location.hoursTitle}</p>
              <p>{t.location.hoursText}</p>
            </div>
          </div>

        </div>

        {/* Bottom copyright */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-[#A39B92] gap-4">
          <p>{t.footer.copyright}</p>
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-location-arrow text-white" />
            <span>Østerbro & Amager 2300</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
